import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutView } from "../../../components/layout/getLayoutView";

export function Works() {
  return (
    <Box sx={{ backgroundColor: "white" }}>
      {getLayoutView(
        <>
          Frequently asked{" "}
          <span style={{ fontFamily: "Lato-Bold" }}>Questions</span>
        </>,
        [
          getLayoutText(
            <>
              Great talent is hard to find. We want to take the time to
              acknowledge a few exceptional people who have contributed to the
              development of the Polycaik platform.
            </>,
            { fontSize: "1.5rem", fontFamily: "Lato-Regular" },
          ),
        ],
        [12],
        {
          textAlign: "center",
          p: `8rem 10%`,
          "& .MuiTypography-root:not(.MuiTypography-caption)": {
            color: (theme) => theme.palette.grey[700],
          },
        },
      )}
      <PkCommonArrow color={`white`} />
      <Box
        sx={{
          p: `8rem 10%`,
          backgroundColor: (theme) => theme.palette.grey[800],
        }}
      >
        {FAQ.map((m) => (
          <Accordion
            key={`${m.issue}`}
            sx={{ backgroundColor: `background.default` }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${m.issue}-content`}
              id={`${m.issue}-id`}
            >
              <Typography variant={`h6`} color={`#eecb4d`}>
                {m.issue}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography fontFamily="Lato-Regular">{m.brief}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
}
const FAQ = [
  {
    issue: "How does the presale work?",
    brief:
      "The Polycaik software is in development. So, we decided to offer an opportunity for those who want to contribute to its development. Signing up at the alpha stage grants you access to every feature scheduled for release, for the software's lifetime. ",
  },
  {
    issue: "How long will the presale last?",
    brief:
      "Typically, 2-months or until enough people have expressed interest in the software offering. The goal is to gather those who are willing to put in the time to learn to utilize Polycaik to release their first application on the platform. Membership will be limited.",
  },
  {
    issue: "When can I access features?",
    brief:
      "Once a feature is ready, you will be notified of its availability and where to find supporting info to help you understand how to use it properly.",
  },
  {
    issue: "How often is the Asset Library updated?",
    brief: "We are committed to updating the Asset Library monthly. ",
  },
  {
    issue: "Can I use my own assets for my game?",
    brief:
      "Yes, when this feature is released, you can upload your assets for use, however, keep in mind their size. Every account has a pre-defined limit for external asset uploads.",
  },
];
